import { render, staticRenderFns } from "./Dynamic-Field.vue?vue&type=template&id=65472f19&"
import script from "./Dynamic-Field.vue?vue&type=script&lang=js&"
export * from "./Dynamic-Field.vue?vue&type=script&lang=js&"
import style0 from "./Dynamic-Field.vue?vue&type=style&index=0&id=65472f19&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports